import * as React from 'react';
export const SvgFolder = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M8 3L6.586 1.586A2 2 0 005.17 1H1a1 1 0 00-1 1v3h16V4a1 1 0 00-1-1z', fill: '#e7b93a' }),
        React.createElement("path", { d: 'M0 14a1 1 0 001 1h14a1 1 0 001-1V5H0z', fill: '#f6d97a' })));
};
export default SvgFolder;
